import type { SVGProps } from 'react'

interface SpiderIconProps {
  size?: number
  className?: string
  'aria-label'?: string
}

/** The cockpit's mascot: curved legs, round body and head, drawn in the current text colour. */
export function SpiderIcon({ size = 16, className, 'aria-label': label }: SpiderIconProps) {
  const a11y: SVGProps<SVGSVGElement> = label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true }
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" className={className} {...a11y}>
      <path
        d="M10 11Q6 9 4 4M9.5 12.5Q5 12 2 10M9.5 14.5Q5 16 3 20M10.5 16Q7 19 7 22M14 11q4-2 6-7M14.5 12.5q4.5-.5 7.5-2.5M14.5 14.5q4.5 1.5 6.5 5.5M13.5 16q3.5 3 3.5 6"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <circle cx="12" cy="14" r="3.6" />
      <circle cx="12" cy="9" r="2.2" />
    </svg>
  )
}
